import React, { FC } from 'react';

const FoodoraCard: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M134.212 163.536H65.9638C49.6278 163.536 36.3398 150.248 36.3398 133.912V65.6639C36.3398 49.3279 49.6278 36.0399 65.9638 36.0399H134.216C150.552 36.0399 163.84 49.3279 163.84 65.6639V133.916C163.836 150.248 150.548 163.536 134.212 163.536Z"
        fill="#FAF9F6"
      />
      <path
        d="M142.712 131.572H58.32C53.428 131.572 49.46 127.604 49.46 122.712V76.5361C49.46 71.6441 53.428 67.6761 58.32 67.6761H142.712C147.604 67.6761 151.572 71.6441 151.572 76.5361V122.708C151.572 127.604 147.604 131.572 142.712 131.572Z"
        fill="#DF1067"
      />
      <path
        d="M74.3237 93.768H61.6557C59.8037 93.768 58.3037 92.268 58.3037 90.416V80.652C58.3037 78.8 59.8037 77.3 61.6557 77.3H74.3237C76.1757 77.3 77.6757 78.8 77.6757 80.652V90.416C77.6797 92.264 76.1757 93.768 74.3237 93.768Z"
        fill="#FF76C9"
      />
      <path
        d="M122.272 125.432C122.272 116.108 129.828 108.552 139.152 108.552C148.476 108.552 156.032 116.108 156.032 125.432C156.032 134.756 148.476 142.312 139.152 142.312C129.828 142.312 122.272 134.756 122.272 125.432Z"
        fill="#0A4342"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.357 125.332C129.357 124.376 130.132 123.602 131.088 123.602H146.832C147.788 123.602 148.562 124.376 148.562 125.332C148.562 126.288 147.788 127.063 146.832 127.063H131.088C130.132 127.063 129.357 126.288 129.357 125.332Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.96 115.934C139.916 115.934 140.69 116.708 140.69 117.664V133.412C140.69 134.368 139.916 135.143 138.96 135.143C138.004 135.143 137.229 134.368 137.229 133.412V117.664C137.229 116.708 138.004 115.934 138.96 115.934Z"
        fill="white"
      />
      <path
        d="M60.0008 111.072H103.313C104.369 111.072 105.221 111.928 105.221 112.98C105.221 114.036 104.365 114.888 103.313 114.888H60.0008C58.9448 114.888 58.0928 114.032 58.0928 112.98C58.0928 111.928 58.9488 111.072 60.0008 111.072Z"
        fill="white"
      />
      <path
        d="M60.0008 119.32H103.313C104.369 119.32 105.221 120.176 105.221 121.228C105.221 122.284 104.365 123.136 103.313 123.136H60.0008C58.9448 123.136 58.0928 122.28 58.0928 121.228C58.0928 120.172 58.9488 119.32 60.0008 119.32Z"
        fill="white"
      />
      <path
        d="M120.012 77.7359H144.372C145.38 77.7359 146.196 78.5519 146.196 79.5599C146.196 80.5679 145.38 81.3839 144.372 81.3839H120.012C119.004 81.3839 118.188 80.5679 118.188 79.5599C118.188 78.5559 119.004 77.7359 120.012 77.7359Z"
        fill="white"
      />
    </svg>
  );
};

export default FoodoraCard;
